var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKulbabka(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6816 53.2698C20.63 50.3969 4.1538 55.4797 1.45688 64.0043C-0.0286853 68.6984 2.27537 75.6351 3.233 78.4548C5.31606 84.6057 8.50408 89.0133 10.7631 91.6693C7.56282 92.6924 5.81534 95.8804 6.53152 98.606C7.07581 100.681 8.98699 102.289 11.3483 102.662C12.0727 104.209 13.5869 105.236 15.2771 105.322C17.8103 105.457 19.259 103.402 19.3327 103.292C22.4962 104.299 25.7456 102.915 26.9365 100.378C27.8082 98.5242 27.4931 96.2324 26.208 94.4194C28.021 92.7579 28.4712 90.1797 27.444 88.334C26.1671 86.0381 22.7417 85.1459 20.098 86.918C18.3587 84.7899 15.9523 81.3113 14.389 76.515C13.3004 73.1673 12.3469 70.0898 13.2309 67.9781C15.2689 63.1285 27.4972 62.4778 43.1999 65.9073C42.6965 61.6921 42.1891 57.4769 41.6857 53.2616L41.6816 53.2698Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1299 90.2393C22.868 90.6976 22.1927 92.0154 22.3687 93.7874C22.5652 95.7395 23.666 96.9754 24.018 97.3356",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1299 90.2393C22.868 90.6976 22.1927 92.0154 22.3687 93.7874C22.5652 95.7395 23.666 96.9754 24.018 97.3356",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.864 96.2021L11.3457 102.668",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0586 96.2021L19.3273 103.303",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.206 94.4312L23.1816 93.7969",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3828 63.3656C109.27 80.2592 124.527 88.2886 132.458 84.1553C136.824 81.8758 140.086 75.336 141.4 72.6677C144.265 66.8401 145.12 61.4667 145.394 57.9922C148.386 59.5269 151.868 58.4997 153.288 56.0647C154.369 54.2149 154.152 51.7226 152.74 49.7909C153.317 48.1826 152.969 46.3901 151.836 45.1337C150.133 43.2512 147.661 43.6809 147.53 43.7054C146.004 40.7589 142.722 39.4452 140.086 40.4028C138.159 41.1026 136.763 42.9442 136.399 45.1378C133.939 45.0355 131.803 46.5456 131.23 48.5755C130.514 51.1046 132.31 54.1535 135.437 54.7633C135.167 57.497 134.418 61.659 132.139 66.1648C130.547 69.3037 129.053 72.1603 126.933 73.0279C122.067 75.025 112.945 66.8564 104.244 53.3432C101.625 56.6867 99.0102 60.0261 96.391 63.3697L96.3828 63.3656Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M135.621 50.2671C136.129 50.128 137.54 49.6696 138.666 48.2904C139.906 46.7721 139.996 45.1147 140.004 44.6113",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M135.621 50.2671C136.129 50.128 137.54 49.6696 138.666 48.2904C139.906 46.7721 139.996 45.1147 140.004 44.6113",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M147.1 53.2982L152.739 49.791",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M143.414 49.623L147.527 43.7012",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M136.4 45.1367L138.095 47.7191",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4316 87.3305C85.6818 104.953 96.9279 122.571 108.178 140.193C107.937 141.437 107.752 143.254 108.178 145.353C109.148 150.17 112.581 152.937 113.662 153.739C122.211 143.794 130.756 133.849 139.305 123.901C138.822 122.403 137.026 117.475 132.856 115.998C127.286 114.026 118.712 118.638 114.955 128.738C103.824 111.693 92.6922 94.6478 81.5607 77.5986C79.1871 80.8399 76.8094 84.0852 74.4357 87.3264L74.4316 87.3305Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1452 94.8459C75.2865 105.957 75.1474 116.43 70.6702 119.732C70.0973 120.158 67.2776 122.061 61.0489 120.027C60.9547 118.222 60.4186 116.917 60.0421 116.172C59.7147 115.529 58.1309 112.411 55.5854 112.202C55.5854 112.202 54.5132 112.177 53.31 112.771C47.511 115.623 48.7019 145.314 49.1153 153.736H72.3399C73.981 148.899 72.7983 144.172 69.7576 142.126C68.2188 141.091 66.4836 140.931 65.2109 140.997C64.3351 137.718 63.4593 134.436 62.5835 131.158C65.1659 131.4 74.378 131.952 80.4225 126.006C88.366 118.189 88.3619 101.578 77.0135 88.3594C74.0588 90.5243 71.104 92.6851 68.1493 94.85L68.1452 94.8459Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5367 108.219L81.828 95.332L77.8951 89.4307L70.7129 96.8912L73.5367 108.219Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0715 98.29L76.5 90.3425L77.0443 79.7594L84.5294 78.8877L95.0715 98.29Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7387 70.603C49.9589 84.0058 36.196 88.1638 28.3017 83.5679C23.1861 80.5886 19.8385 73.5373 21.2831 67.6728C23.3498 59.2874 35.3898 52.6413 49.5251 56.656C52.263 61.305 55.0008 65.954 57.7387 70.603Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3667 54.7878C32.0569 57.1819 20.1601 49.1074 18.7605 40.0754C17.852 34.2273 21.2282 27.1842 26.6917 24.6182C34.5042 20.9432 47.2522 26.116 53.0307 39.6252C51.1441 44.6794 49.2534 49.7336 47.3667 54.7878Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2876 37.2154C41.8574 26.751 40.7361 12.4192 46.9157 5.68716C50.9181 1.3246 58.526 -0.435151 63.9444 2.22904C71.6914 6.03911 75.612 19.2209 68.6671 32.1735C63.5392 33.8555 58.4114 35.5375 53.2876 37.2154Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2578 28.5463C73.8197 13.261 85.2335 4.52358 94.2451 6.04597C100.081 7.03225 105.7 12.4548 106.412 18.4502C107.431 27.0239 98.5054 37.4883 83.8585 38.7078C79.6596 35.3193 75.4567 31.9348 71.2578 28.5463Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0703 42.2088C98.8689 32.1659 113.233 32.8289 119.147 39.7942C122.977 44.3082 123.784 52.0716 120.469 57.1176C115.73 64.3326 102.159 66.5916 90.1683 58.0957C89.137 52.8001 88.1016 47.5044 87.0703 42.2088Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5343 60.3545C102.967 61.7418 112.556 72.4559 111.725 81.5575C111.189 87.4506 106.208 93.4665 100.286 94.637C91.815 96.3067 80.6999 88.2077 78.3672 73.6959C81.4242 69.2474 84.4813 64.803 87.5343 60.3545Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5067 71.3818C83.4215 84.7028 80.3522 98.7481 72.4865 103.405C67.3955 106.421 59.6034 105.91 55.1877 101.793C48.873 95.9038 48.9303 82.1532 59.3251 71.7624C64.719 71.6356 70.1128 71.5087 75.5067 71.3818Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6143 76.5166C82.4522 76.5166 92.8594 66.1094 92.8594 53.2715C92.8594 40.4336 82.4522 30.0264 69.6143 30.0264C56.7763 30.0264 46.3691 40.4336 46.3691 53.2715C46.3691 66.1094 56.7763 76.5166 69.6143 76.5166Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2683 48.1068C99.2683 42.0924 94.3927 37.2168 88.3783 37.2168C82.3639 37.2168 77.4883 42.0924 77.4883 48.1068V50.0753C77.4883 56.0897 82.3639 60.9653 88.3783 60.9653C94.3927 60.9653 99.2683 56.0897 99.2683 50.0753V48.1068Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M89.434 55.4477C92.1417 55.4477 94.3368 52.3274 94.3368 48.4782C94.3368 44.6291 92.1417 41.5088 89.434 41.5088C86.7263 41.5088 84.5312 44.6291 84.5312 48.4782C84.5312 52.3274 86.7263 55.4477 89.434 55.4477Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7763 39.4082L89.6465 44.9166L83.25 43.869L87.7763 39.4082Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8836 48.7054C80.8836 42.6911 76.0079 37.8154 69.9935 37.8154C63.9791 37.8154 59.1035 42.6911 59.1035 48.7054V50.6739C59.1035 56.6883 63.9791 61.5639 69.9935 61.5639C76.0079 61.5639 80.8836 56.6883 80.8836 50.6739V48.7054Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0473 56.0551C73.755 56.0551 75.9501 52.9348 75.9501 49.0857C75.9501 45.2365 73.755 42.1162 71.0473 42.1162C68.3396 42.1162 66.1445 45.2365 66.1445 49.0857C66.1445 52.9348 68.3396 56.0551 71.0473 56.0551Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3876 40.0156L71.2578 45.5282L64.8613 44.4764L69.3876 40.0156Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4548 34.513L72.8736 32.98C74.5636 32.6723 75.6841 31.0529 75.3764 29.3629L75.2694 28.7751C74.9616 27.0851 73.3422 25.9646 71.6522 26.2723L63.2333 27.8053C61.5434 28.113 60.4229 29.7325 60.7306 31.4225L60.8376 32.0103C61.1453 33.7003 62.7648 34.8208 64.4548 34.513Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5081 28.1527L87.0892 26.6197C85.3993 26.312 83.7798 27.4325 83.4721 29.1224L83.3651 29.7103C83.0573 31.4002 84.1779 33.0197 85.8678 33.3274L94.2867 34.8604C95.9767 35.1682 97.5961 34.0476 97.9039 32.3577L98.0109 31.7698C98.3186 30.0799 97.1981 28.4604 95.5081 28.1527Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3161 68.2907C77.3722 69.3752 75.2072 69.3875 73.8117 68.2907C73.1447 67.7668 72.7804 67.0916 72.584 66.5596",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2073 140.996C64.3643 141.193 63.2634 141.549 62.093 142.216C61.3932 142.613 60.8161 143.038 60.3496 143.435L63.2552 133.675L65.2114 141L65.2073 140.996Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKulbabka);
export default __webpack_public_path__ + "static/media/kulbabka.e48606da88e6017f28fc9d2faafad40f.svg";
export { ForwardRef as ReactComponent };